import { render } from "./NerdyView.vue?vue&type=template&id=529f22f6&scoped=true"
import script from "./NerdyView.vue?vue&type=script&lang=js"
export * from "./NerdyView.vue?vue&type=script&lang=js"

import "./NerdyView.vue?vue&type=style&index=0&id=529f22f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529f22f6"]])

export default __exports__